import { createContext, useContext } from 'react'
import type { useSummaryTriage } from '@/components/analysis/summary/process-summary/tabs/hooks/useSummaryTriage'
import type { SummaryItem } from '@/components/analysis/summary/types/triage'

export interface ImprovementCanvasApi {
	scrollToIssue: (issueId: string) => boolean
}

export interface ImprovementOverlayContextValue {
	items: SummaryItem[]
	triage: ReturnType<typeof useSummaryTriage>
	numberMap: Map<string, string>
	titleMap: Map<string, string>
	orderedItems: SummaryItem[]
	readOnly: boolean
	expandIssue: (issueId: string) => void
	showProcessLevel: (issueIds: string[]) => void
	pendingOpenIssueId: string | null
	consumePendingOpen: () => void
	registerCanvasApi: (api: ImprovementCanvasApi | null) => void
}

const ImprovementOverlayContext = createContext<ImprovementOverlayContextValue | null>(null)

export const ImprovementOverlayProvider = ImprovementOverlayContext.Provider

export function useImprovementOverlay(): ImprovementOverlayContextValue | null {
	return useContext(ImprovementOverlayContext)
}
